/* @flow */

import React from 'react';
import { Segment, Header, Form, Grid } from 'semantic-ui-react';
import OctoResourceCard from 'shared/components/OctoResourceCard';
import type { FlowHeader } from 'catalog/plugins/flow/simple';

type Props = {
  header: FlowHeader,
  strategy: ResourceStrategy,
  onUpdate: (header: FlowHeader) => void,
};

const HeaderForm = ({ header, strategy, onUpdate }: Props) => {
  const inputChanged = event =>
    onUpdate({
      ...header,
      [event.target.name]: event.target.value,
    });

  const imageUpdated = image =>
    onUpdate({
      ...header,
      image,
    });

  const imageDeleted = () =>
    onUpdate({
      ...header,
      image: undefined,
    });

  return (
    <Segment>
      <Grid columns={2}>
        <Grid.Column verticalAlign="middle">
          <Form>
            <Form.Field>
              <label>Titre</label>
              <input
                name="title"
                placeholder="Titre"
                value={header.title || ''}
                onChange={inputChanged}
              />
            </Form.Field>
            <Form.Field>
              <label>Titre court</label>
              <input
                name="shortTitle"
                placeholder="Titre court"
                value={header.shortTitle || ''}
                onChange={inputChanged}
              />
            </Form.Field>
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Header as="h3" textAlign="center">Image de titre</Header>
          <OctoResourceCard
            resource={header.image}
            strategy={strategy}
            onUpdated={imageUpdated}
            onDeleted={imageDeleted}
          />
        </Grid.Column>
      </Grid>
    </Segment>
  );
};

export default HeaderForm;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/flow/simple/components/HeaderForm.js